module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-144x144.png";